/**
 * Loads the first display set from an imported study into the active viewport.
 */
export function openImportedStudyInViewport(
  servicesManager: AppTypes.ServicesManager,
  commandsManager: AppTypes.CommandsManager,
  studyInstanceUID: string | string[]
): void {
  const { displaySetService, viewportGridService, hangingProtocolService } =
    servicesManager.services;
  const { activeViewportId, isHangingProtocolLayout } = viewportGridService.getState();

  const studyInstanceUIDs = Array.isArray(studyInstanceUID) ? studyInstanceUID : [studyInstanceUID];

  if (!activeViewportId || !studyInstanceUIDs.length) {
    return;
  }

  const preferredStudyUID = Array.isArray(studyInstanceUID) ? null : studyInstanceUID;

  const studyDisplaySets = displaySetService.activeDisplaySets.filter(
    ds =>
      studyInstanceUIDs.includes(ds.StudyInstanceUID) &&
      !ds.unsupported &&
      (!preferredStudyUID || ds.StudyInstanceUID === preferredStudyUID)
  );

  const displaySet = studyDisplaySets[0];

  if (!displaySet) {
    return;
  }

  try {
    const viewportsToUpdate = hangingProtocolService.getViewportsRequireUpdate(
      activeViewportId,
      displaySet.displaySetInstanceUID,
      isHangingProtocolLayout
    );

    commandsManager.run('setDisplaySetsForViewports', { viewportsToUpdate });
  } catch {
    commandsManager.run('setDisplaySetsForViewports', {
      viewportsToUpdate: [
        {
          viewportId: activeViewportId,
          displaySetInstanceUIDs: [displaySet.displaySetInstanceUID],
        },
      ],
    });
  }
}
